import { ArrowUpRight, BriefcaseMedical, ClipboardList, MapPin, User, UsersRoundIcon } from "lucide-react";
import React, { useEffect } from "react";
import {useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "../dashboard/Dashboard.css";
import { t } from "../../locales/translate";
export default function DashboardStats() {
  const history = useHistory();

  const { data, loading } = useSelector((state) => state.stats);

  const stats = [
    { title: `${t("activeEmployee")}`, path: "/admin/employees", count: data.activeEmployees, icon: <User color="#22AD5C" size={20} /> },
    { title:`${t("totalDoctors")}`, path: "/admin/doctors", count: data.totalDoctors, icon: <UsersRoundIcon color="#2D68F8" size={20} /> },
    { title: `${t("visitProfiles")}`, path: "/admin/visitProfiles", count: data.totalVisitProfiles, icon: <ClipboardList color="#F27430" size={20} /> },
    { title: `${t("practiceLocations")}`, path: "/admin/practiceLocations", count: data.totalPracticeLocations, icon: <MapPin color="#FBBF24" size={20} /> },
  ];

  return (
    <div className="stats-container">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="stats-card"
          onClick={() => history.push(stat.path)}
        >
          <div className="stats-card-header">
            <div className="stats-card-title">
              {stat.icon}
              <span>{stat.title}</span>
            </div>
            <ArrowUpRight size={20} />
          </div>
          <span className="stats-card-count">{stat.count}</span>
        </div>
      ))}
    </div>
  );
};

